import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _82a2bcac = () => interopDefault(import('../src/app/pages/apply/index.vue' /* webpackChunkName: "pages/apply/index" */))
const _2c2ee79c = () => interopDefault(import('../src/app/pages/contact/index.vue' /* webpackChunkName: "pages/contact/index" */))
const _d6f8a53c = () => interopDefault(import('../src/app/pages/download/index.vue' /* webpackChunkName: "pages/download/index" */))
const _a94d9f02 = () => interopDefault(import('../src/app/pages/enquiry/index.vue' /* webpackChunkName: "pages/enquiry/index" */))
const _02248392 = () => interopDefault(import('../src/app/pages/faqs/index.vue' /* webpackChunkName: "pages/faqs/index" */))
const _68c9f8b8 = () => interopDefault(import('../src/app/pages/logout/index.vue' /* webpackChunkName: "pages/logout/index" */))
const _38890eea = () => interopDefault(import('../src/app/pages/my-planner/index.vue' /* webpackChunkName: "pages/my-planner/index" */))
const _47d5a4d5 = () => interopDefault(import('../src/app/pages/notes-depricated/index.vue' /* webpackChunkName: "pages/notes-depricated/index" */))
const _b5d45c1e = () => interopDefault(import('../src/app/pages/scripthouse/index.vue' /* webpackChunkName: "pages/scripthouse/index" */))
const _71c522f2 = () => interopDefault(import('../src/app/pages/spaces/index.vue' /* webpackChunkName: "pages/spaces/index" */))
const _1ccb5c83 = () => interopDefault(import('../src/app/pages/terms/index.vue' /* webpackChunkName: "pages/terms/index" */))
const _69a69d90 = () => interopDefault(import('../src/app/pages/account/create/index.vue' /* webpackChunkName: "pages/account/create/index" */))
const _336e1802 = () => interopDefault(import('../src/app/pages/account/expired/index.vue' /* webpackChunkName: "pages/account/expired/index" */))
const _55f965dc = () => interopDefault(import('../src/app/pages/account/frozen/index.vue' /* webpackChunkName: "pages/account/frozen/index" */))
const _18bfe408 = () => interopDefault(import('../src/app/pages/account/not-active/index.vue' /* webpackChunkName: "pages/account/not-active/index" */))
const _62fb17ba = () => interopDefault(import('../src/app/pages/account/overdue/index.vue' /* webpackChunkName: "pages/account/overdue/index" */))
const _48236b75 = () => interopDefault(import('../src/app/pages/account/suspended/index.vue' /* webpackChunkName: "pages/account/suspended/index" */))
const _3530dbc4 = () => interopDefault(import('../src/app/pages/account/verified/index.vue' /* webpackChunkName: "pages/account/verified/index" */))
const _1b5e2075 = () => interopDefault(import('../src/app/pages/account/verify/index.vue' /* webpackChunkName: "pages/account/verify/index" */))
const _ff33fcd4 = () => interopDefault(import('../src/app/pages/apply/submitted/index.vue' /* webpackChunkName: "pages/apply/submitted/index" */))
const _6ae3e14e = () => interopDefault(import('../config/authPage.js' /* webpackChunkName: "" */))
const _60881a1c = () => interopDefault(import('../src/app/pages/bedrooms/search/index.vue' /* webpackChunkName: "pages/bedrooms/search/index" */))
const _645997cb = () => interopDefault(import('../src/app/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _44c7876e = () => interopDefault(import('../src/app/pages/enquiry/enquiry-options.js' /* webpackChunkName: "pages/enquiry/enquiry-options" */))
const _2c9db53a = () => interopDefault(import('../src/app/pages/faqs/house-pay/index.vue' /* webpackChunkName: "pages/faqs/house-pay/index" */))
const _83e3f9aa = () => interopDefault(import('../src/app/pages/introduction/analytics/index.vue' /* webpackChunkName: "pages/introduction/analytics/index" */))
const _3df344f8 = () => interopDefault(import('../src/app/pages/introduction/appointment/index.vue' /* webpackChunkName: "pages/introduction/appointment/index" */))
const _4753938f = () => interopDefault(import('../src/app/pages/introduction/calendar/index.vue' /* webpackChunkName: "pages/introduction/calendar/index" */))
const _748c8fa8 = () => interopDefault(import('../src/app/pages/introduction/schedule/index.vue' /* webpackChunkName: "pages/introduction/schedule/index" */))
const _134a78ec = () => interopDefault(import('../src/app/pages/introduction/terms/index.vue' /* webpackChunkName: "pages/introduction/terms/index" */))
const _2fa34af2 = () => interopDefault(import('../src/app/pages/introduction/welcome/index.vue' /* webpackChunkName: "pages/introduction/welcome/index" */))
const _65219f83 = () => interopDefault(import('../src/app/pages/policy/analytics/index.vue' /* webpackChunkName: "pages/policy/analytics/index" */))
const _16c4ea87 = () => interopDefault(import('../src/app/pages/policy/house-rules/index.vue' /* webpackChunkName: "pages/policy/house-rules/index" */))
const _99d184f6 = () => interopDefault(import('../src/app/pages/policy/privacy/index.vue' /* webpackChunkName: "pages/policy/privacy/index" */))
const _20541208 = () => interopDefault(import('../src/app/pages/settings/applications.vue' /* webpackChunkName: "pages/settings/applications" */))
const _0843d123 = () => interopDefault(import('../src/app/pages/settings/calendar.vue' /* webpackChunkName: "pages/settings/calendar" */))
const _1b790ff8 = () => interopDefault(import('../src/app/pages/settings/houses.vue' /* webpackChunkName: "pages/settings/houses" */))
const _0286f27b = () => interopDefault(import('../src/app/pages/settings/membership.vue' /* webpackChunkName: "pages/settings/membership" */))
const _3f159a00 = () => interopDefault(import('../src/app/pages/settings/password.vue' /* webpackChunkName: "pages/settings/password" */))
const _8bc58118 = () => interopDefault(import('../src/app/pages/settings/payment/index.vue' /* webpackChunkName: "pages/settings/payment/index" */))
const _11d26c30 = () => interopDefault(import('../src/app/pages/settings/perks.vue' /* webpackChunkName: "pages/settings/perks" */))
const _f435b7ba = () => interopDefault(import('../src/app/pages/settings/preferences.vue' /* webpackChunkName: "pages/settings/preferences" */))
const _1d9bdf8a = () => interopDefault(import('../src/app/pages/settings/previous-bookings.vue' /* webpackChunkName: "pages/settings/previous-bookings" */))
const _3ba36058 = () => interopDefault(import('../src/app/pages/settings/profile.vue' /* webpackChunkName: "pages/settings/profile" */))
const _718654af = () => interopDefault(import('../src/app/pages/terms/house-pay/index.vue' /* webpackChunkName: "pages/terms/house-pay/index" */))
const _d3e731ea = () => interopDefault(import('../src/app/pages/account/verify/expired/index.vue' /* webpackChunkName: "pages/account/verify/expired/index" */))
const _31be61c4 = () => interopDefault(import('../src/app/pages/settings/payment/add-method/index.vue' /* webpackChunkName: "pages/settings/payment/add-method/index" */))
const _2f3fb954 = () => interopDefault(import('../src/app/pages/settings/payment/callback/index.vue' /* webpackChunkName: "pages/settings/payment/callback/index" */))
const _4c76ead9 = () => interopDefault(import('../src/app/pages/bedrooms/bookings/_id/index.vue' /* webpackChunkName: "pages/bedrooms/bookings/_id/index" */))
const _27f59a70 = () => interopDefault(import('../src/app/pages/bedrooms/promotion/_id/index.vue' /* webpackChunkName: "pages/bedrooms/promotion/_id/index" */))
const _4e2fbb96 = () => interopDefault(import('../src/app/pages/whats-on/details/_id/index.vue' /* webpackChunkName: "pages/whats-on/details/_id/index" */))
const _a5731c74 = () => interopDefault(import('../src/app/pages/bedrooms/bookings/_id/cancel/index.vue' /* webpackChunkName: "pages/bedrooms/bookings/_id/cancel/index" */))
const _7aa027f4 = () => interopDefault(import('../src/app/pages/bedrooms/bookings/_id/modify/index.vue' /* webpackChunkName: "pages/bedrooms/bookings/_id/modify/index" */))
const _50412b88 = () => interopDefault(import('../src/app/pages/bedrooms/bookings/_id/cancel/cancelled/index.vue' /* webpackChunkName: "pages/bedrooms/bookings/_id/cancel/cancelled/index" */))
const _28bb47d5 = () => interopDefault(import('../src/app/pages/bedrooms/bookings/_id/modify/_availId/_rateId/index.vue' /* webpackChunkName: "pages/bedrooms/bookings/_id/modify/_availId/_rateId/index" */))
const _0254d839 = () => interopDefault(import('../src/app/pages/bedrooms/bookings/_id/modify/_availId/_rateId/book/index.vue' /* webpackChunkName: "pages/bedrooms/bookings/_id/modify/_availId/_rateId/book/index" */))
const _2781afac = () => interopDefault(import('../src/app/pages/bedrooms/availability/_availId/_rateId/index.vue' /* webpackChunkName: "pages/bedrooms/availability/_availId/_rateId/index" */))
const _fd4e827c = () => interopDefault(import('../src/app/pages/bedrooms/availability/_availId/_rateId/book/index.vue' /* webpackChunkName: "pages/bedrooms/availability/_availId/_rateId/book/index" */))
const _030055d2 = () => interopDefault(import('../src/app/pages/house/_slug/index.vue' /* webpackChunkName: "pages/house/_slug/index" */))
const _42136580 = () => interopDefault(import('../src/app/pages/notes-depricated/_id/index.vue' /* webpackChunkName: "pages/notes-depricated/_id/index" */))
const _53ff3b2c = () => interopDefault(import('../src/app/pages/perks/_id/index.vue' /* webpackChunkName: "pages/perks/_id/index" */))
const _103ce8a1 = () => interopDefault(import('../src/app/pages/whats-on/_type/index.vue' /* webpackChunkName: "pages/whats-on/_type/index" */))
const _53be6956 = () => interopDefault(import('../src/app/pages/apply/_id/basics/index.vue' /* webpackChunkName: "pages/apply/_id/basics/index" */))
const _642e6df0 = () => interopDefault(import('../src/app/pages/apply/_id/details/index.vue' /* webpackChunkName: "pages/apply/_id/details/index" */))
const _2b9d560c = () => interopDefault(import('../src/app/pages/apply/_id/package/index.vue' /* webpackChunkName: "pages/apply/_id/package/index" */))
const _5745e524 = () => interopDefault(import('../src/app/pages/apply/_id/pay/index.vue' /* webpackChunkName: "pages/apply/_id/pay/index" */))
const _5f3bc4e8 = () => interopDefault(import('../src/app/pages/apply/_id/review/index.vue' /* webpackChunkName: "pages/apply/_id/review/index" */))
const _efbadf86 = () => interopDefault(import('../src/app/pages/apply/_id/rules/index.vue' /* webpackChunkName: "pages/apply/_id/rules/index" */))
const _286fe43f = () => interopDefault(import('../src/app/pages/house/_slug/rules/index.vue' /* webpackChunkName: "pages/house/_slug/rules/index" */))
const _57949f63 = () => interopDefault(import('../src/app/pages/house/_slug/tours/index.vue' /* webpackChunkName: "pages/house/_slug/tours/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/apply",
    component: _82a2bcac,
    name: "apply___en"
  }, {
    path: "/contact",
    component: _2c2ee79c,
    name: "contact___en"
  }, {
    path: "/download",
    component: _d6f8a53c,
    name: "download___en"
  }, {
    path: "/enquiry",
    component: _a94d9f02,
    name: "enquiry___en"
  }, {
    path: "/faqs",
    component: _02248392,
    name: "faqs___en"
  }, {
    path: "/logout",
    component: _68c9f8b8,
    name: "logout___en"
  }, {
    path: "/my-planner",
    component: _38890eea,
    name: "my-planner___en"
  }, {
    path: "/notes-depricated",
    component: _47d5a4d5,
    name: "notes-depricated___en"
  }, {
    path: "/scripthouse",
    component: _b5d45c1e,
    name: "scripthouse___en"
  }, {
    path: "/spaces",
    component: _71c522f2,
    name: "spaces___en"
  }, {
    path: "/terms",
    component: _1ccb5c83,
    name: "terms___en"
  }, {
    path: "/account/create",
    component: _69a69d90,
    name: "account-create___en"
  }, {
    path: "/account/expired",
    component: _336e1802,
    name: "account-expired___en"
  }, {
    path: "/account/frozen",
    component: _55f965dc,
    name: "account-frozen___en"
  }, {
    path: "/account/not-active",
    component: _18bfe408,
    name: "account-not-active___en"
  }, {
    path: "/account/overdue",
    component: _62fb17ba,
    name: "account-overdue___en"
  }, {
    path: "/account/suspended",
    component: _48236b75,
    name: "account-suspended___en"
  }, {
    path: "/account/verified",
    component: _3530dbc4,
    name: "account-verified___en"
  }, {
    path: "/account/verify",
    component: _1b5e2075,
    name: "account-verify___en"
  }, {
    path: "/apply/submitted",
    component: _ff33fcd4,
    name: "apply-submitted___en"
  }, {
    path: "/auth/login",
    component: _6ae3e14e,
    name: "oauth-login___en"
  }, {
    path: "/auth/logout",
    component: _6ae3e14e,
    name: "oauth-logout___en"
  }, {
    path: "/bedrooms/search",
    component: _60881a1c,
    name: "bedrooms-search___en"
  }, {
    path: "/ca/",
    component: _645997cb,
    name: "index___ca"
  }, {
    path: "/ca/apply",
    component: _82a2bcac,
    name: "apply___ca"
  }, {
    path: "/ca/contact",
    component: _2c2ee79c,
    name: "contact___ca"
  }, {
    path: "/ca/download",
    component: _d6f8a53c,
    name: "download___ca"
  }, {
    path: "/ca/enquiry",
    component: _a94d9f02,
    name: "enquiry___ca"
  }, {
    path: "/ca/faqs",
    component: _02248392,
    name: "faqs___ca"
  }, {
    path: "/ca/logout",
    component: _68c9f8b8,
    name: "logout___ca"
  }, {
    path: "/ca/my-planner",
    component: _38890eea,
    name: "my-planner___ca"
  }, {
    path: "/ca/notes-depricated",
    component: _47d5a4d5,
    name: "notes-depricated___ca"
  }, {
    path: "/ca/scripthouse",
    component: _b5d45c1e,
    name: "scripthouse___ca"
  }, {
    path: "/ca/spaces",
    component: _71c522f2,
    name: "spaces___ca"
  }, {
    path: "/ca/terms",
    component: _1ccb5c83,
    name: "terms___ca"
  }, {
    path: "/de/",
    component: _645997cb,
    name: "index___de"
  }, {
    path: "/de/apply",
    component: _82a2bcac,
    name: "apply___de"
  }, {
    path: "/de/contact",
    component: _2c2ee79c,
    name: "contact___de"
  }, {
    path: "/de/download",
    component: _d6f8a53c,
    name: "download___de"
  }, {
    path: "/de/enquiry",
    component: _a94d9f02,
    name: "enquiry___de"
  }, {
    path: "/de/faqs",
    component: _02248392,
    name: "faqs___de"
  }, {
    path: "/de/logout",
    component: _68c9f8b8,
    name: "logout___de"
  }, {
    path: "/de/my-planner",
    component: _38890eea,
    name: "my-planner___de"
  }, {
    path: "/de/notes-depricated",
    component: _47d5a4d5,
    name: "notes-depricated___de"
  }, {
    path: "/de/scripthouse",
    component: _b5d45c1e,
    name: "scripthouse___de"
  }, {
    path: "/de/spaces",
    component: _71c522f2,
    name: "spaces___de"
  }, {
    path: "/de/terms",
    component: _1ccb5c83,
    name: "terms___de"
  }, {
    path: "/en-us/",
    component: _645997cb,
    name: "index___en-us"
  }, {
    path: "/en-us/apply",
    component: _82a2bcac,
    name: "apply___en-us"
  }, {
    path: "/en-us/contact",
    component: _2c2ee79c,
    name: "contact___en-us"
  }, {
    path: "/en-us/download",
    component: _d6f8a53c,
    name: "download___en-us"
  }, {
    path: "/en-us/enquiry",
    component: _a94d9f02,
    name: "enquiry___en-us"
  }, {
    path: "/en-us/faqs",
    component: _02248392,
    name: "faqs___en-us"
  }, {
    path: "/en-us/logout",
    component: _68c9f8b8,
    name: "logout___en-us"
  }, {
    path: "/en-us/my-planner",
    component: _38890eea,
    name: "my-planner___en-us"
  }, {
    path: "/en-us/notes-depricated",
    component: _47d5a4d5,
    name: "notes-depricated___en-us"
  }, {
    path: "/en-us/scripthouse",
    component: _b5d45c1e,
    name: "scripthouse___en-us"
  }, {
    path: "/en-us/spaces",
    component: _71c522f2,
    name: "spaces___en-us"
  }, {
    path: "/en-us/terms",
    component: _1ccb5c83,
    name: "terms___en-us"
  }, {
    path: "/enquiry/enquiry-options",
    component: _44c7876e,
    name: "enquiry-enquiry-options___en"
  }, {
    path: "/es/",
    component: _645997cb,
    name: "index___es"
  }, {
    path: "/es/apply",
    component: _82a2bcac,
    name: "apply___es"
  }, {
    path: "/es/contact",
    component: _2c2ee79c,
    name: "contact___es"
  }, {
    path: "/es/download",
    component: _d6f8a53c,
    name: "download___es"
  }, {
    path: "/es/enquiry",
    component: _a94d9f02,
    name: "enquiry___es"
  }, {
    path: "/es/faqs",
    component: _02248392,
    name: "faqs___es"
  }, {
    path: "/es/logout",
    component: _68c9f8b8,
    name: "logout___es"
  }, {
    path: "/es/my-planner",
    component: _38890eea,
    name: "my-planner___es"
  }, {
    path: "/es/notes-depricated",
    component: _47d5a4d5,
    name: "notes-depricated___es"
  }, {
    path: "/es/scripthouse",
    component: _b5d45c1e,
    name: "scripthouse___es"
  }, {
    path: "/es/spaces",
    component: _71c522f2,
    name: "spaces___es"
  }, {
    path: "/es/terms",
    component: _1ccb5c83,
    name: "terms___es"
  }, {
    path: "/faqs/house-pay",
    component: _2c9db53a,
    name: "faqs-house-pay___en"
  }, {
    path: "/fr/",
    component: _645997cb,
    name: "index___fr"
  }, {
    path: "/fr/apply",
    component: _82a2bcac,
    name: "apply___fr"
  }, {
    path: "/fr/contact",
    component: _2c2ee79c,
    name: "contact___fr"
  }, {
    path: "/fr/download",
    component: _d6f8a53c,
    name: "download___fr"
  }, {
    path: "/fr/enquiry",
    component: _a94d9f02,
    name: "enquiry___fr"
  }, {
    path: "/fr/faqs",
    component: _02248392,
    name: "faqs___fr"
  }, {
    path: "/fr/logout",
    component: _68c9f8b8,
    name: "logout___fr"
  }, {
    path: "/fr/my-planner",
    component: _38890eea,
    name: "my-planner___fr"
  }, {
    path: "/fr/notes-depricated",
    component: _47d5a4d5,
    name: "notes-depricated___fr"
  }, {
    path: "/fr/scripthouse",
    component: _b5d45c1e,
    name: "scripthouse___fr"
  }, {
    path: "/fr/spaces",
    component: _71c522f2,
    name: "spaces___fr"
  }, {
    path: "/fr/terms",
    component: _1ccb5c83,
    name: "terms___fr"
  }, {
    path: "/introduction/analytics",
    component: _83e3f9aa,
    name: "introduction-analytics___en"
  }, {
    path: "/introduction/appointment",
    component: _3df344f8,
    name: "introduction-appointment___en"
  }, {
    path: "/introduction/calendar",
    component: _4753938f,
    name: "introduction-calendar___en"
  }, {
    path: "/introduction/schedule",
    component: _748c8fa8,
    name: "introduction-schedule___en"
  }, {
    path: "/introduction/terms",
    component: _134a78ec,
    name: "introduction-terms___en"
  }, {
    path: "/introduction/welcome",
    component: _2fa34af2,
    name: "introduction-welcome___en"
  }, {
    path: "/ja/",
    component: _645997cb,
    name: "index___ja"
  }, {
    path: "/ja/apply",
    component: _82a2bcac,
    name: "apply___ja"
  }, {
    path: "/ja/contact",
    component: _2c2ee79c,
    name: "contact___ja"
  }, {
    path: "/ja/download",
    component: _d6f8a53c,
    name: "download___ja"
  }, {
    path: "/ja/enquiry",
    component: _a94d9f02,
    name: "enquiry___ja"
  }, {
    path: "/ja/faqs",
    component: _02248392,
    name: "faqs___ja"
  }, {
    path: "/ja/logout",
    component: _68c9f8b8,
    name: "logout___ja"
  }, {
    path: "/ja/my-planner",
    component: _38890eea,
    name: "my-planner___ja"
  }, {
    path: "/ja/notes-depricated",
    component: _47d5a4d5,
    name: "notes-depricated___ja"
  }, {
    path: "/ja/scripthouse",
    component: _b5d45c1e,
    name: "scripthouse___ja"
  }, {
    path: "/ja/spaces",
    component: _71c522f2,
    name: "spaces___ja"
  }, {
    path: "/ja/terms",
    component: _1ccb5c83,
    name: "terms___ja"
  }, {
    path: "/ko/",
    component: _645997cb,
    name: "index___ko"
  }, {
    path: "/ko/apply",
    component: _82a2bcac,
    name: "apply___ko"
  }, {
    path: "/ko/contact",
    component: _2c2ee79c,
    name: "contact___ko"
  }, {
    path: "/ko/download",
    component: _d6f8a53c,
    name: "download___ko"
  }, {
    path: "/ko/enquiry",
    component: _a94d9f02,
    name: "enquiry___ko"
  }, {
    path: "/ko/faqs",
    component: _02248392,
    name: "faqs___ko"
  }, {
    path: "/ko/logout",
    component: _68c9f8b8,
    name: "logout___ko"
  }, {
    path: "/ko/my-planner",
    component: _38890eea,
    name: "my-planner___ko"
  }, {
    path: "/ko/notes-depricated",
    component: _47d5a4d5,
    name: "notes-depricated___ko"
  }, {
    path: "/ko/scripthouse",
    component: _b5d45c1e,
    name: "scripthouse___ko"
  }, {
    path: "/ko/spaces",
    component: _71c522f2,
    name: "spaces___ko"
  }, {
    path: "/ko/terms",
    component: _1ccb5c83,
    name: "terms___ko"
  }, {
    path: "/policy/analytics",
    component: _65219f83,
    name: "policy-analytics___en"
  }, {
    path: "/policy/house-rules",
    component: _16c4ea87,
    name: "policy-house-rules___en"
  }, {
    path: "/policy/privacy",
    component: _99d184f6,
    name: "policy-privacy___en"
  }, {
    path: "/settings/applications",
    component: _20541208,
    name: "settings-applications___en"
  }, {
    path: "/settings/calendar",
    component: _0843d123,
    name: "settings-calendar___en"
  }, {
    path: "/settings/houses",
    component: _1b790ff8,
    name: "settings-houses___en"
  }, {
    path: "/settings/membership",
    component: _0286f27b,
    name: "settings-membership___en"
  }, {
    path: "/settings/password",
    component: _3f159a00,
    name: "settings-password___en"
  }, {
    path: "/settings/payment",
    component: _8bc58118,
    name: "settings-payment___en"
  }, {
    path: "/settings/perks",
    component: _11d26c30,
    name: "settings-perks___en"
  }, {
    path: "/settings/preferences",
    component: _f435b7ba,
    name: "settings-preferences___en"
  }, {
    path: "/settings/previous-bookings",
    component: _1d9bdf8a,
    name: "settings-previous-bookings___en"
  }, {
    path: "/settings/profile",
    component: _3ba36058,
    name: "settings-profile___en"
  }, {
    path: "/terms/house-pay",
    component: _718654af,
    name: "terms-house-pay___en"
  }, {
    path: "/tr/",
    component: _645997cb,
    name: "index___tr"
  }, {
    path: "/tr/apply",
    component: _82a2bcac,
    name: "apply___tr"
  }, {
    path: "/tr/contact",
    component: _2c2ee79c,
    name: "contact___tr"
  }, {
    path: "/tr/download",
    component: _d6f8a53c,
    name: "download___tr"
  }, {
    path: "/tr/enquiry",
    component: _a94d9f02,
    name: "enquiry___tr"
  }, {
    path: "/tr/faqs",
    component: _02248392,
    name: "faqs___tr"
  }, {
    path: "/tr/logout",
    component: _68c9f8b8,
    name: "logout___tr"
  }, {
    path: "/tr/my-planner",
    component: _38890eea,
    name: "my-planner___tr"
  }, {
    path: "/tr/notes-depricated",
    component: _47d5a4d5,
    name: "notes-depricated___tr"
  }, {
    path: "/tr/scripthouse",
    component: _b5d45c1e,
    name: "scripthouse___tr"
  }, {
    path: "/tr/spaces",
    component: _71c522f2,
    name: "spaces___tr"
  }, {
    path: "/tr/terms",
    component: _1ccb5c83,
    name: "terms___tr"
  }, {
    path: "/zh/",
    component: _645997cb,
    name: "index___zh"
  }, {
    path: "/zh/apply",
    component: _82a2bcac,
    name: "apply___zh"
  }, {
    path: "/zh/contact",
    component: _2c2ee79c,
    name: "contact___zh"
  }, {
    path: "/zh/download",
    component: _d6f8a53c,
    name: "download___zh"
  }, {
    path: "/zh/enquiry",
    component: _a94d9f02,
    name: "enquiry___zh"
  }, {
    path: "/zh/faqs",
    component: _02248392,
    name: "faqs___zh"
  }, {
    path: "/zh/logout",
    component: _68c9f8b8,
    name: "logout___zh"
  }, {
    path: "/zh/my-planner",
    component: _38890eea,
    name: "my-planner___zh"
  }, {
    path: "/zh/notes-depricated",
    component: _47d5a4d5,
    name: "notes-depricated___zh"
  }, {
    path: "/zh/scripthouse",
    component: _b5d45c1e,
    name: "scripthouse___zh"
  }, {
    path: "/zh/spaces",
    component: _71c522f2,
    name: "spaces___zh"
  }, {
    path: "/zh/terms",
    component: _1ccb5c83,
    name: "terms___zh"
  }, {
    path: "/account/verify/expired",
    component: _d3e731ea,
    name: "account-verify-expired___en"
  }, {
    path: "/ca/account/create",
    component: _69a69d90,
    name: "account-create___ca"
  }, {
    path: "/ca/account/expired",
    component: _336e1802,
    name: "account-expired___ca"
  }, {
    path: "/ca/account/frozen",
    component: _55f965dc,
    name: "account-frozen___ca"
  }, {
    path: "/ca/account/not-active",
    component: _18bfe408,
    name: "account-not-active___ca"
  }, {
    path: "/ca/account/overdue",
    component: _62fb17ba,
    name: "account-overdue___ca"
  }, {
    path: "/ca/account/suspended",
    component: _48236b75,
    name: "account-suspended___ca"
  }, {
    path: "/ca/account/verified",
    component: _3530dbc4,
    name: "account-verified___ca"
  }, {
    path: "/ca/account/verify",
    component: _1b5e2075,
    name: "account-verify___ca"
  }, {
    path: "/ca/apply/submitted",
    component: _ff33fcd4,
    name: "apply-submitted___ca"
  }, {
    path: "/ca/auth/login",
    component: _6ae3e14e,
    name: "oauth-login___ca"
  }, {
    path: "/ca/auth/logout",
    component: _6ae3e14e,
    name: "oauth-logout___ca"
  }, {
    path: "/ca/bedrooms/search",
    component: _60881a1c,
    name: "bedrooms-search___ca"
  }, {
    path: "/ca/enquiry/enquiry-options",
    component: _44c7876e,
    name: "enquiry-enquiry-options___ca"
  }, {
    path: "/ca/faqs/house-pay",
    component: _2c9db53a,
    name: "faqs-house-pay___ca"
  }, {
    path: "/ca/introduction/analytics",
    component: _83e3f9aa,
    name: "introduction-analytics___ca"
  }, {
    path: "/ca/introduction/appointment",
    component: _3df344f8,
    name: "introduction-appointment___ca"
  }, {
    path: "/ca/introduction/calendar",
    component: _4753938f,
    name: "introduction-calendar___ca"
  }, {
    path: "/ca/introduction/schedule",
    component: _748c8fa8,
    name: "introduction-schedule___ca"
  }, {
    path: "/ca/introduction/terms",
    component: _134a78ec,
    name: "introduction-terms___ca"
  }, {
    path: "/ca/introduction/welcome",
    component: _2fa34af2,
    name: "introduction-welcome___ca"
  }, {
    path: "/ca/policy/analytics",
    component: _65219f83,
    name: "policy-analytics___ca"
  }, {
    path: "/ca/policy/house-rules",
    component: _16c4ea87,
    name: "policy-house-rules___ca"
  }, {
    path: "/ca/policy/privacy",
    component: _99d184f6,
    name: "policy-privacy___ca"
  }, {
    path: "/ca/settings/applications",
    component: _20541208,
    name: "settings-applications___ca"
  }, {
    path: "/ca/settings/calendar",
    component: _0843d123,
    name: "settings-calendar___ca"
  }, {
    path: "/ca/settings/houses",
    component: _1b790ff8,
    name: "settings-houses___ca"
  }, {
    path: "/ca/settings/membership",
    component: _0286f27b,
    name: "settings-membership___ca"
  }, {
    path: "/ca/settings/password",
    component: _3f159a00,
    name: "settings-password___ca"
  }, {
    path: "/ca/settings/payment",
    component: _8bc58118,
    name: "settings-payment___ca"
  }, {
    path: "/ca/settings/perks",
    component: _11d26c30,
    name: "settings-perks___ca"
  }, {
    path: "/ca/settings/preferences",
    component: _f435b7ba,
    name: "settings-preferences___ca"
  }, {
    path: "/ca/settings/previous-bookings",
    component: _1d9bdf8a,
    name: "settings-previous-bookings___ca"
  }, {
    path: "/ca/settings/profile",
    component: _3ba36058,
    name: "settings-profile___ca"
  }, {
    path: "/ca/terms/house-pay",
    component: _718654af,
    name: "terms-house-pay___ca"
  }, {
    path: "/de/account/create",
    component: _69a69d90,
    name: "account-create___de"
  }, {
    path: "/de/account/expired",
    component: _336e1802,
    name: "account-expired___de"
  }, {
    path: "/de/account/frozen",
    component: _55f965dc,
    name: "account-frozen___de"
  }, {
    path: "/de/account/not-active",
    component: _18bfe408,
    name: "account-not-active___de"
  }, {
    path: "/de/account/overdue",
    component: _62fb17ba,
    name: "account-overdue___de"
  }, {
    path: "/de/account/suspended",
    component: _48236b75,
    name: "account-suspended___de"
  }, {
    path: "/de/account/verified",
    component: _3530dbc4,
    name: "account-verified___de"
  }, {
    path: "/de/account/verify",
    component: _1b5e2075,
    name: "account-verify___de"
  }, {
    path: "/de/apply/submitted",
    component: _ff33fcd4,
    name: "apply-submitted___de"
  }, {
    path: "/de/auth/login",
    component: _6ae3e14e,
    name: "oauth-login___de"
  }, {
    path: "/de/auth/logout",
    component: _6ae3e14e,
    name: "oauth-logout___de"
  }, {
    path: "/de/bedrooms/search",
    component: _60881a1c,
    name: "bedrooms-search___de"
  }, {
    path: "/de/enquiry/enquiry-options",
    component: _44c7876e,
    name: "enquiry-enquiry-options___de"
  }, {
    path: "/de/faqs/house-pay",
    component: _2c9db53a,
    name: "faqs-house-pay___de"
  }, {
    path: "/de/introduction/analytics",
    component: _83e3f9aa,
    name: "introduction-analytics___de"
  }, {
    path: "/de/introduction/appointment",
    component: _3df344f8,
    name: "introduction-appointment___de"
  }, {
    path: "/de/introduction/calendar",
    component: _4753938f,
    name: "introduction-calendar___de"
  }, {
    path: "/de/introduction/schedule",
    component: _748c8fa8,
    name: "introduction-schedule___de"
  }, {
    path: "/de/introduction/terms",
    component: _134a78ec,
    name: "introduction-terms___de"
  }, {
    path: "/de/introduction/welcome",
    component: _2fa34af2,
    name: "introduction-welcome___de"
  }, {
    path: "/de/policy/analytics",
    component: _65219f83,
    name: "policy-analytics___de"
  }, {
    path: "/de/policy/house-rules",
    component: _16c4ea87,
    name: "policy-house-rules___de"
  }, {
    path: "/de/policy/privacy",
    component: _99d184f6,
    name: "policy-privacy___de"
  }, {
    path: "/de/settings/applications",
    component: _20541208,
    name: "settings-applications___de"
  }, {
    path: "/de/settings/calendar",
    component: _0843d123,
    name: "settings-calendar___de"
  }, {
    path: "/de/settings/houses",
    component: _1b790ff8,
    name: "settings-houses___de"
  }, {
    path: "/de/settings/membership",
    component: _0286f27b,
    name: "settings-membership___de"
  }, {
    path: "/de/settings/password",
    component: _3f159a00,
    name: "settings-password___de"
  }, {
    path: "/de/settings/payment",
    component: _8bc58118,
    name: "settings-payment___de"
  }, {
    path: "/de/settings/perks",
    component: _11d26c30,
    name: "settings-perks___de"
  }, {
    path: "/de/settings/preferences",
    component: _f435b7ba,
    name: "settings-preferences___de"
  }, {
    path: "/de/settings/previous-bookings",
    component: _1d9bdf8a,
    name: "settings-previous-bookings___de"
  }, {
    path: "/de/settings/profile",
    component: _3ba36058,
    name: "settings-profile___de"
  }, {
    path: "/de/terms/house-pay",
    component: _718654af,
    name: "terms-house-pay___de"
  }, {
    path: "/en-us/account/create",
    component: _69a69d90,
    name: "account-create___en-us"
  }, {
    path: "/en-us/account/expired",
    component: _336e1802,
    name: "account-expired___en-us"
  }, {
    path: "/en-us/account/frozen",
    component: _55f965dc,
    name: "account-frozen___en-us"
  }, {
    path: "/en-us/account/not-active",
    component: _18bfe408,
    name: "account-not-active___en-us"
  }, {
    path: "/en-us/account/overdue",
    component: _62fb17ba,
    name: "account-overdue___en-us"
  }, {
    path: "/en-us/account/suspended",
    component: _48236b75,
    name: "account-suspended___en-us"
  }, {
    path: "/en-us/account/verified",
    component: _3530dbc4,
    name: "account-verified___en-us"
  }, {
    path: "/en-us/account/verify",
    component: _1b5e2075,
    name: "account-verify___en-us"
  }, {
    path: "/en-us/apply/submitted",
    component: _ff33fcd4,
    name: "apply-submitted___en-us"
  }, {
    path: "/en-us/auth/login",
    component: _6ae3e14e,
    name: "oauth-login___en-us"
  }, {
    path: "/en-us/auth/logout",
    component: _6ae3e14e,
    name: "oauth-logout___en-us"
  }, {
    path: "/en-us/bedrooms/search",
    component: _60881a1c,
    name: "bedrooms-search___en-us"
  }, {
    path: "/en-us/enquiry/enquiry-options",
    component: _44c7876e,
    name: "enquiry-enquiry-options___en-us"
  }, {
    path: "/en-us/faqs/house-pay",
    component: _2c9db53a,
    name: "faqs-house-pay___en-us"
  }, {
    path: "/en-us/introduction/analytics",
    component: _83e3f9aa,
    name: "introduction-analytics___en-us"
  }, {
    path: "/en-us/introduction/appointment",
    component: _3df344f8,
    name: "introduction-appointment___en-us"
  }, {
    path: "/en-us/introduction/calendar",
    component: _4753938f,
    name: "introduction-calendar___en-us"
  }, {
    path: "/en-us/introduction/schedule",
    component: _748c8fa8,
    name: "introduction-schedule___en-us"
  }, {
    path: "/en-us/introduction/terms",
    component: _134a78ec,
    name: "introduction-terms___en-us"
  }, {
    path: "/en-us/introduction/welcome",
    component: _2fa34af2,
    name: "introduction-welcome___en-us"
  }, {
    path: "/en-us/policy/analytics",
    component: _65219f83,
    name: "policy-analytics___en-us"
  }, {
    path: "/en-us/policy/house-rules",
    component: _16c4ea87,
    name: "policy-house-rules___en-us"
  }, {
    path: "/en-us/policy/privacy",
    component: _99d184f6,
    name: "policy-privacy___en-us"
  }, {
    path: "/en-us/settings/applications",
    component: _20541208,
    name: "settings-applications___en-us"
  }, {
    path: "/en-us/settings/calendar",
    component: _0843d123,
    name: "settings-calendar___en-us"
  }, {
    path: "/en-us/settings/houses",
    component: _1b790ff8,
    name: "settings-houses___en-us"
  }, {
    path: "/en-us/settings/membership",
    component: _0286f27b,
    name: "settings-membership___en-us"
  }, {
    path: "/en-us/settings/password",
    component: _3f159a00,
    name: "settings-password___en-us"
  }, {
    path: "/en-us/settings/payment",
    component: _8bc58118,
    name: "settings-payment___en-us"
  }, {
    path: "/en-us/settings/perks",
    component: _11d26c30,
    name: "settings-perks___en-us"
  }, {
    path: "/en-us/settings/preferences",
    component: _f435b7ba,
    name: "settings-preferences___en-us"
  }, {
    path: "/en-us/settings/previous-bookings",
    component: _1d9bdf8a,
    name: "settings-previous-bookings___en-us"
  }, {
    path: "/en-us/settings/profile",
    component: _3ba36058,
    name: "settings-profile___en-us"
  }, {
    path: "/en-us/terms/house-pay",
    component: _718654af,
    name: "terms-house-pay___en-us"
  }, {
    path: "/es/account/create",
    component: _69a69d90,
    name: "account-create___es"
  }, {
    path: "/es/account/expired",
    component: _336e1802,
    name: "account-expired___es"
  }, {
    path: "/es/account/frozen",
    component: _55f965dc,
    name: "account-frozen___es"
  }, {
    path: "/es/account/not-active",
    component: _18bfe408,
    name: "account-not-active___es"
  }, {
    path: "/es/account/overdue",
    component: _62fb17ba,
    name: "account-overdue___es"
  }, {
    path: "/es/account/suspended",
    component: _48236b75,
    name: "account-suspended___es"
  }, {
    path: "/es/account/verified",
    component: _3530dbc4,
    name: "account-verified___es"
  }, {
    path: "/es/account/verify",
    component: _1b5e2075,
    name: "account-verify___es"
  }, {
    path: "/es/apply/submitted",
    component: _ff33fcd4,
    name: "apply-submitted___es"
  }, {
    path: "/es/auth/login",
    component: _6ae3e14e,
    name: "oauth-login___es"
  }, {
    path: "/es/auth/logout",
    component: _6ae3e14e,
    name: "oauth-logout___es"
  }, {
    path: "/es/bedrooms/search",
    component: _60881a1c,
    name: "bedrooms-search___es"
  }, {
    path: "/es/enquiry/enquiry-options",
    component: _44c7876e,
    name: "enquiry-enquiry-options___es"
  }, {
    path: "/es/faqs/house-pay",
    component: _2c9db53a,
    name: "faqs-house-pay___es"
  }, {
    path: "/es/introduction/analytics",
    component: _83e3f9aa,
    name: "introduction-analytics___es"
  }, {
    path: "/es/introduction/appointment",
    component: _3df344f8,
    name: "introduction-appointment___es"
  }, {
    path: "/es/introduction/calendar",
    component: _4753938f,
    name: "introduction-calendar___es"
  }, {
    path: "/es/introduction/schedule",
    component: _748c8fa8,
    name: "introduction-schedule___es"
  }, {
    path: "/es/introduction/terms",
    component: _134a78ec,
    name: "introduction-terms___es"
  }, {
    path: "/es/introduction/welcome",
    component: _2fa34af2,
    name: "introduction-welcome___es"
  }, {
    path: "/es/policy/analytics",
    component: _65219f83,
    name: "policy-analytics___es"
  }, {
    path: "/es/policy/house-rules",
    component: _16c4ea87,
    name: "policy-house-rules___es"
  }, {
    path: "/es/policy/privacy",
    component: _99d184f6,
    name: "policy-privacy___es"
  }, {
    path: "/es/settings/applications",
    component: _20541208,
    name: "settings-applications___es"
  }, {
    path: "/es/settings/calendar",
    component: _0843d123,
    name: "settings-calendar___es"
  }, {
    path: "/es/settings/houses",
    component: _1b790ff8,
    name: "settings-houses___es"
  }, {
    path: "/es/settings/membership",
    component: _0286f27b,
    name: "settings-membership___es"
  }, {
    path: "/es/settings/password",
    component: _3f159a00,
    name: "settings-password___es"
  }, {
    path: "/es/settings/payment",
    component: _8bc58118,
    name: "settings-payment___es"
  }, {
    path: "/es/settings/perks",
    component: _11d26c30,
    name: "settings-perks___es"
  }, {
    path: "/es/settings/preferences",
    component: _f435b7ba,
    name: "settings-preferences___es"
  }, {
    path: "/es/settings/previous-bookings",
    component: _1d9bdf8a,
    name: "settings-previous-bookings___es"
  }, {
    path: "/es/settings/profile",
    component: _3ba36058,
    name: "settings-profile___es"
  }, {
    path: "/es/terms/house-pay",
    component: _718654af,
    name: "terms-house-pay___es"
  }, {
    path: "/fr/account/create",
    component: _69a69d90,
    name: "account-create___fr"
  }, {
    path: "/fr/account/expired",
    component: _336e1802,
    name: "account-expired___fr"
  }, {
    path: "/fr/account/frozen",
    component: _55f965dc,
    name: "account-frozen___fr"
  }, {
    path: "/fr/account/not-active",
    component: _18bfe408,
    name: "account-not-active___fr"
  }, {
    path: "/fr/account/overdue",
    component: _62fb17ba,
    name: "account-overdue___fr"
  }, {
    path: "/fr/account/suspended",
    component: _48236b75,
    name: "account-suspended___fr"
  }, {
    path: "/fr/account/verified",
    component: _3530dbc4,
    name: "account-verified___fr"
  }, {
    path: "/fr/account/verify",
    component: _1b5e2075,
    name: "account-verify___fr"
  }, {
    path: "/fr/apply/submitted",
    component: _ff33fcd4,
    name: "apply-submitted___fr"
  }, {
    path: "/fr/auth/login",
    component: _6ae3e14e,
    name: "oauth-login___fr"
  }, {
    path: "/fr/auth/logout",
    component: _6ae3e14e,
    name: "oauth-logout___fr"
  }, {
    path: "/fr/bedrooms/search",
    component: _60881a1c,
    name: "bedrooms-search___fr"
  }, {
    path: "/fr/enquiry/enquiry-options",
    component: _44c7876e,
    name: "enquiry-enquiry-options___fr"
  }, {
    path: "/fr/faqs/house-pay",
    component: _2c9db53a,
    name: "faqs-house-pay___fr"
  }, {
    path: "/fr/introduction/analytics",
    component: _83e3f9aa,
    name: "introduction-analytics___fr"
  }, {
    path: "/fr/introduction/appointment",
    component: _3df344f8,
    name: "introduction-appointment___fr"
  }, {
    path: "/fr/introduction/calendar",
    component: _4753938f,
    name: "introduction-calendar___fr"
  }, {
    path: "/fr/introduction/schedule",
    component: _748c8fa8,
    name: "introduction-schedule___fr"
  }, {
    path: "/fr/introduction/terms",
    component: _134a78ec,
    name: "introduction-terms___fr"
  }, {
    path: "/fr/introduction/welcome",
    component: _2fa34af2,
    name: "introduction-welcome___fr"
  }, {
    path: "/fr/policy/analytics",
    component: _65219f83,
    name: "policy-analytics___fr"
  }, {
    path: "/fr/policy/house-rules",
    component: _16c4ea87,
    name: "policy-house-rules___fr"
  }, {
    path: "/fr/policy/privacy",
    component: _99d184f6,
    name: "policy-privacy___fr"
  }, {
    path: "/fr/settings/applications",
    component: _20541208,
    name: "settings-applications___fr"
  }, {
    path: "/fr/settings/calendar",
    component: _0843d123,
    name: "settings-calendar___fr"
  }, {
    path: "/fr/settings/houses",
    component: _1b790ff8,
    name: "settings-houses___fr"
  }, {
    path: "/fr/settings/membership",
    component: _0286f27b,
    name: "settings-membership___fr"
  }, {
    path: "/fr/settings/password",
    component: _3f159a00,
    name: "settings-password___fr"
  }, {
    path: "/fr/settings/payment",
    component: _8bc58118,
    name: "settings-payment___fr"
  }, {
    path: "/fr/settings/perks",
    component: _11d26c30,
    name: "settings-perks___fr"
  }, {
    path: "/fr/settings/preferences",
    component: _f435b7ba,
    name: "settings-preferences___fr"
  }, {
    path: "/fr/settings/previous-bookings",
    component: _1d9bdf8a,
    name: "settings-previous-bookings___fr"
  }, {
    path: "/fr/settings/profile",
    component: _3ba36058,
    name: "settings-profile___fr"
  }, {
    path: "/fr/terms/house-pay",
    component: _718654af,
    name: "terms-house-pay___fr"
  }, {
    path: "/ja/account/create",
    component: _69a69d90,
    name: "account-create___ja"
  }, {
    path: "/ja/account/expired",
    component: _336e1802,
    name: "account-expired___ja"
  }, {
    path: "/ja/account/frozen",
    component: _55f965dc,
    name: "account-frozen___ja"
  }, {
    path: "/ja/account/not-active",
    component: _18bfe408,
    name: "account-not-active___ja"
  }, {
    path: "/ja/account/overdue",
    component: _62fb17ba,
    name: "account-overdue___ja"
  }, {
    path: "/ja/account/suspended",
    component: _48236b75,
    name: "account-suspended___ja"
  }, {
    path: "/ja/account/verified",
    component: _3530dbc4,
    name: "account-verified___ja"
  }, {
    path: "/ja/account/verify",
    component: _1b5e2075,
    name: "account-verify___ja"
  }, {
    path: "/ja/apply/submitted",
    component: _ff33fcd4,
    name: "apply-submitted___ja"
  }, {
    path: "/ja/auth/login",
    component: _6ae3e14e,
    name: "oauth-login___ja"
  }, {
    path: "/ja/auth/logout",
    component: _6ae3e14e,
    name: "oauth-logout___ja"
  }, {
    path: "/ja/bedrooms/search",
    component: _60881a1c,
    name: "bedrooms-search___ja"
  }, {
    path: "/ja/enquiry/enquiry-options",
    component: _44c7876e,
    name: "enquiry-enquiry-options___ja"
  }, {
    path: "/ja/faqs/house-pay",
    component: _2c9db53a,
    name: "faqs-house-pay___ja"
  }, {
    path: "/ja/introduction/analytics",
    component: _83e3f9aa,
    name: "introduction-analytics___ja"
  }, {
    path: "/ja/introduction/appointment",
    component: _3df344f8,
    name: "introduction-appointment___ja"
  }, {
    path: "/ja/introduction/calendar",
    component: _4753938f,
    name: "introduction-calendar___ja"
  }, {
    path: "/ja/introduction/schedule",
    component: _748c8fa8,
    name: "introduction-schedule___ja"
  }, {
    path: "/ja/introduction/terms",
    component: _134a78ec,
    name: "introduction-terms___ja"
  }, {
    path: "/ja/introduction/welcome",
    component: _2fa34af2,
    name: "introduction-welcome___ja"
  }, {
    path: "/ja/policy/analytics",
    component: _65219f83,
    name: "policy-analytics___ja"
  }, {
    path: "/ja/policy/house-rules",
    component: _16c4ea87,
    name: "policy-house-rules___ja"
  }, {
    path: "/ja/policy/privacy",
    component: _99d184f6,
    name: "policy-privacy___ja"
  }, {
    path: "/ja/settings/applications",
    component: _20541208,
    name: "settings-applications___ja"
  }, {
    path: "/ja/settings/calendar",
    component: _0843d123,
    name: "settings-calendar___ja"
  }, {
    path: "/ja/settings/houses",
    component: _1b790ff8,
    name: "settings-houses___ja"
  }, {
    path: "/ja/settings/membership",
    component: _0286f27b,
    name: "settings-membership___ja"
  }, {
    path: "/ja/settings/password",
    component: _3f159a00,
    name: "settings-password___ja"
  }, {
    path: "/ja/settings/payment",
    component: _8bc58118,
    name: "settings-payment___ja"
  }, {
    path: "/ja/settings/perks",
    component: _11d26c30,
    name: "settings-perks___ja"
  }, {
    path: "/ja/settings/preferences",
    component: _f435b7ba,
    name: "settings-preferences___ja"
  }, {
    path: "/ja/settings/previous-bookings",
    component: _1d9bdf8a,
    name: "settings-previous-bookings___ja"
  }, {
    path: "/ja/settings/profile",
    component: _3ba36058,
    name: "settings-profile___ja"
  }, {
    path: "/ja/terms/house-pay",
    component: _718654af,
    name: "terms-house-pay___ja"
  }, {
    path: "/ko/account/create",
    component: _69a69d90,
    name: "account-create___ko"
  }, {
    path: "/ko/account/expired",
    component: _336e1802,
    name: "account-expired___ko"
  }, {
    path: "/ko/account/frozen",
    component: _55f965dc,
    name: "account-frozen___ko"
  }, {
    path: "/ko/account/not-active",
    component: _18bfe408,
    name: "account-not-active___ko"
  }, {
    path: "/ko/account/overdue",
    component: _62fb17ba,
    name: "account-overdue___ko"
  }, {
    path: "/ko/account/suspended",
    component: _48236b75,
    name: "account-suspended___ko"
  }, {
    path: "/ko/account/verified",
    component: _3530dbc4,
    name: "account-verified___ko"
  }, {
    path: "/ko/account/verify",
    component: _1b5e2075,
    name: "account-verify___ko"
  }, {
    path: "/ko/apply/submitted",
    component: _ff33fcd4,
    name: "apply-submitted___ko"
  }, {
    path: "/ko/auth/login",
    component: _6ae3e14e,
    name: "oauth-login___ko"
  }, {
    path: "/ko/auth/logout",
    component: _6ae3e14e,
    name: "oauth-logout___ko"
  }, {
    path: "/ko/bedrooms/search",
    component: _60881a1c,
    name: "bedrooms-search___ko"
  }, {
    path: "/ko/enquiry/enquiry-options",
    component: _44c7876e,
    name: "enquiry-enquiry-options___ko"
  }, {
    path: "/ko/faqs/house-pay",
    component: _2c9db53a,
    name: "faqs-house-pay___ko"
  }, {
    path: "/ko/introduction/analytics",
    component: _83e3f9aa,
    name: "introduction-analytics___ko"
  }, {
    path: "/ko/introduction/appointment",
    component: _3df344f8,
    name: "introduction-appointment___ko"
  }, {
    path: "/ko/introduction/calendar",
    component: _4753938f,
    name: "introduction-calendar___ko"
  }, {
    path: "/ko/introduction/schedule",
    component: _748c8fa8,
    name: "introduction-schedule___ko"
  }, {
    path: "/ko/introduction/terms",
    component: _134a78ec,
    name: "introduction-terms___ko"
  }, {
    path: "/ko/introduction/welcome",
    component: _2fa34af2,
    name: "introduction-welcome___ko"
  }, {
    path: "/ko/policy/analytics",
    component: _65219f83,
    name: "policy-analytics___ko"
  }, {
    path: "/ko/policy/house-rules",
    component: _16c4ea87,
    name: "policy-house-rules___ko"
  }, {
    path: "/ko/policy/privacy",
    component: _99d184f6,
    name: "policy-privacy___ko"
  }, {
    path: "/ko/settings/applications",
    component: _20541208,
    name: "settings-applications___ko"
  }, {
    path: "/ko/settings/calendar",
    component: _0843d123,
    name: "settings-calendar___ko"
  }, {
    path: "/ko/settings/houses",
    component: _1b790ff8,
    name: "settings-houses___ko"
  }, {
    path: "/ko/settings/membership",
    component: _0286f27b,
    name: "settings-membership___ko"
  }, {
    path: "/ko/settings/password",
    component: _3f159a00,
    name: "settings-password___ko"
  }, {
    path: "/ko/settings/payment",
    component: _8bc58118,
    name: "settings-payment___ko"
  }, {
    path: "/ko/settings/perks",
    component: _11d26c30,
    name: "settings-perks___ko"
  }, {
    path: "/ko/settings/preferences",
    component: _f435b7ba,
    name: "settings-preferences___ko"
  }, {
    path: "/ko/settings/previous-bookings",
    component: _1d9bdf8a,
    name: "settings-previous-bookings___ko"
  }, {
    path: "/ko/settings/profile",
    component: _3ba36058,
    name: "settings-profile___ko"
  }, {
    path: "/ko/terms/house-pay",
    component: _718654af,
    name: "terms-house-pay___ko"
  }, {
    path: "/settings/payment/add-method",
    component: _31be61c4,
    name: "settings-payment-add-method___en"
  }, {
    path: "/settings/payment/callback",
    component: _2f3fb954,
    name: "settings-payment-callback___en"
  }, {
    path: "/tr/account/create",
    component: _69a69d90,
    name: "account-create___tr"
  }, {
    path: "/tr/account/expired",
    component: _336e1802,
    name: "account-expired___tr"
  }, {
    path: "/tr/account/frozen",
    component: _55f965dc,
    name: "account-frozen___tr"
  }, {
    path: "/tr/account/not-active",
    component: _18bfe408,
    name: "account-not-active___tr"
  }, {
    path: "/tr/account/overdue",
    component: _62fb17ba,
    name: "account-overdue___tr"
  }, {
    path: "/tr/account/suspended",
    component: _48236b75,
    name: "account-suspended___tr"
  }, {
    path: "/tr/account/verified",
    component: _3530dbc4,
    name: "account-verified___tr"
  }, {
    path: "/tr/account/verify",
    component: _1b5e2075,
    name: "account-verify___tr"
  }, {
    path: "/tr/apply/submitted",
    component: _ff33fcd4,
    name: "apply-submitted___tr"
  }, {
    path: "/tr/auth/login",
    component: _6ae3e14e,
    name: "oauth-login___tr"
  }, {
    path: "/tr/auth/logout",
    component: _6ae3e14e,
    name: "oauth-logout___tr"
  }, {
    path: "/tr/bedrooms/search",
    component: _60881a1c,
    name: "bedrooms-search___tr"
  }, {
    path: "/tr/enquiry/enquiry-options",
    component: _44c7876e,
    name: "enquiry-enquiry-options___tr"
  }, {
    path: "/tr/faqs/house-pay",
    component: _2c9db53a,
    name: "faqs-house-pay___tr"
  }, {
    path: "/tr/introduction/analytics",
    component: _83e3f9aa,
    name: "introduction-analytics___tr"
  }, {
    path: "/tr/introduction/appointment",
    component: _3df344f8,
    name: "introduction-appointment___tr"
  }, {
    path: "/tr/introduction/calendar",
    component: _4753938f,
    name: "introduction-calendar___tr"
  }, {
    path: "/tr/introduction/schedule",
    component: _748c8fa8,
    name: "introduction-schedule___tr"
  }, {
    path: "/tr/introduction/terms",
    component: _134a78ec,
    name: "introduction-terms___tr"
  }, {
    path: "/tr/introduction/welcome",
    component: _2fa34af2,
    name: "introduction-welcome___tr"
  }, {
    path: "/tr/policy/analytics",
    component: _65219f83,
    name: "policy-analytics___tr"
  }, {
    path: "/tr/policy/house-rules",
    component: _16c4ea87,
    name: "policy-house-rules___tr"
  }, {
    path: "/tr/policy/privacy",
    component: _99d184f6,
    name: "policy-privacy___tr"
  }, {
    path: "/tr/settings/applications",
    component: _20541208,
    name: "settings-applications___tr"
  }, {
    path: "/tr/settings/calendar",
    component: _0843d123,
    name: "settings-calendar___tr"
  }, {
    path: "/tr/settings/houses",
    component: _1b790ff8,
    name: "settings-houses___tr"
  }, {
    path: "/tr/settings/membership",
    component: _0286f27b,
    name: "settings-membership___tr"
  }, {
    path: "/tr/settings/password",
    component: _3f159a00,
    name: "settings-password___tr"
  }, {
    path: "/tr/settings/payment",
    component: _8bc58118,
    name: "settings-payment___tr"
  }, {
    path: "/tr/settings/perks",
    component: _11d26c30,
    name: "settings-perks___tr"
  }, {
    path: "/tr/settings/preferences",
    component: _f435b7ba,
    name: "settings-preferences___tr"
  }, {
    path: "/tr/settings/previous-bookings",
    component: _1d9bdf8a,
    name: "settings-previous-bookings___tr"
  }, {
    path: "/tr/settings/profile",
    component: _3ba36058,
    name: "settings-profile___tr"
  }, {
    path: "/tr/terms/house-pay",
    component: _718654af,
    name: "terms-house-pay___tr"
  }, {
    path: "/zh/account/create",
    component: _69a69d90,
    name: "account-create___zh"
  }, {
    path: "/zh/account/expired",
    component: _336e1802,
    name: "account-expired___zh"
  }, {
    path: "/zh/account/frozen",
    component: _55f965dc,
    name: "account-frozen___zh"
  }, {
    path: "/zh/account/not-active",
    component: _18bfe408,
    name: "account-not-active___zh"
  }, {
    path: "/zh/account/overdue",
    component: _62fb17ba,
    name: "account-overdue___zh"
  }, {
    path: "/zh/account/suspended",
    component: _48236b75,
    name: "account-suspended___zh"
  }, {
    path: "/zh/account/verified",
    component: _3530dbc4,
    name: "account-verified___zh"
  }, {
    path: "/zh/account/verify",
    component: _1b5e2075,
    name: "account-verify___zh"
  }, {
    path: "/zh/apply/submitted",
    component: _ff33fcd4,
    name: "apply-submitted___zh"
  }, {
    path: "/zh/auth/login",
    component: _6ae3e14e,
    name: "oauth-login___zh"
  }, {
    path: "/zh/auth/logout",
    component: _6ae3e14e,
    name: "oauth-logout___zh"
  }, {
    path: "/zh/bedrooms/search",
    component: _60881a1c,
    name: "bedrooms-search___zh"
  }, {
    path: "/zh/enquiry/enquiry-options",
    component: _44c7876e,
    name: "enquiry-enquiry-options___zh"
  }, {
    path: "/zh/faqs/house-pay",
    component: _2c9db53a,
    name: "faqs-house-pay___zh"
  }, {
    path: "/zh/introduction/analytics",
    component: _83e3f9aa,
    name: "introduction-analytics___zh"
  }, {
    path: "/zh/introduction/appointment",
    component: _3df344f8,
    name: "introduction-appointment___zh"
  }, {
    path: "/zh/introduction/calendar",
    component: _4753938f,
    name: "introduction-calendar___zh"
  }, {
    path: "/zh/introduction/schedule",
    component: _748c8fa8,
    name: "introduction-schedule___zh"
  }, {
    path: "/zh/introduction/terms",
    component: _134a78ec,
    name: "introduction-terms___zh"
  }, {
    path: "/zh/introduction/welcome",
    component: _2fa34af2,
    name: "introduction-welcome___zh"
  }, {
    path: "/zh/policy/analytics",
    component: _65219f83,
    name: "policy-analytics___zh"
  }, {
    path: "/zh/policy/house-rules",
    component: _16c4ea87,
    name: "policy-house-rules___zh"
  }, {
    path: "/zh/policy/privacy",
    component: _99d184f6,
    name: "policy-privacy___zh"
  }, {
    path: "/zh/settings/applications",
    component: _20541208,
    name: "settings-applications___zh"
  }, {
    path: "/zh/settings/calendar",
    component: _0843d123,
    name: "settings-calendar___zh"
  }, {
    path: "/zh/settings/houses",
    component: _1b790ff8,
    name: "settings-houses___zh"
  }, {
    path: "/zh/settings/membership",
    component: _0286f27b,
    name: "settings-membership___zh"
  }, {
    path: "/zh/settings/password",
    component: _3f159a00,
    name: "settings-password___zh"
  }, {
    path: "/zh/settings/payment",
    component: _8bc58118,
    name: "settings-payment___zh"
  }, {
    path: "/zh/settings/perks",
    component: _11d26c30,
    name: "settings-perks___zh"
  }, {
    path: "/zh/settings/preferences",
    component: _f435b7ba,
    name: "settings-preferences___zh"
  }, {
    path: "/zh/settings/previous-bookings",
    component: _1d9bdf8a,
    name: "settings-previous-bookings___zh"
  }, {
    path: "/zh/settings/profile",
    component: _3ba36058,
    name: "settings-profile___zh"
  }, {
    path: "/zh/terms/house-pay",
    component: _718654af,
    name: "terms-house-pay___zh"
  }, {
    path: "/ca/account/verify/expired",
    component: _d3e731ea,
    name: "account-verify-expired___ca"
  }, {
    path: "/ca/settings/payment/add-method",
    component: _31be61c4,
    name: "settings-payment-add-method___ca"
  }, {
    path: "/ca/settings/payment/callback",
    component: _2f3fb954,
    name: "settings-payment-callback___ca"
  }, {
    path: "/de/account/verify/expired",
    component: _d3e731ea,
    name: "account-verify-expired___de"
  }, {
    path: "/de/settings/payment/add-method",
    component: _31be61c4,
    name: "settings-payment-add-method___de"
  }, {
    path: "/de/settings/payment/callback",
    component: _2f3fb954,
    name: "settings-payment-callback___de"
  }, {
    path: "/en-us/account/verify/expired",
    component: _d3e731ea,
    name: "account-verify-expired___en-us"
  }, {
    path: "/en-us/settings/payment/add-method",
    component: _31be61c4,
    name: "settings-payment-add-method___en-us"
  }, {
    path: "/en-us/settings/payment/callback",
    component: _2f3fb954,
    name: "settings-payment-callback___en-us"
  }, {
    path: "/es/account/verify/expired",
    component: _d3e731ea,
    name: "account-verify-expired___es"
  }, {
    path: "/es/settings/payment/add-method",
    component: _31be61c4,
    name: "settings-payment-add-method___es"
  }, {
    path: "/es/settings/payment/callback",
    component: _2f3fb954,
    name: "settings-payment-callback___es"
  }, {
    path: "/fr/account/verify/expired",
    component: _d3e731ea,
    name: "account-verify-expired___fr"
  }, {
    path: "/fr/settings/payment/add-method",
    component: _31be61c4,
    name: "settings-payment-add-method___fr"
  }, {
    path: "/fr/settings/payment/callback",
    component: _2f3fb954,
    name: "settings-payment-callback___fr"
  }, {
    path: "/ja/account/verify/expired",
    component: _d3e731ea,
    name: "account-verify-expired___ja"
  }, {
    path: "/ja/settings/payment/add-method",
    component: _31be61c4,
    name: "settings-payment-add-method___ja"
  }, {
    path: "/ja/settings/payment/callback",
    component: _2f3fb954,
    name: "settings-payment-callback___ja"
  }, {
    path: "/ko/account/verify/expired",
    component: _d3e731ea,
    name: "account-verify-expired___ko"
  }, {
    path: "/ko/settings/payment/add-method",
    component: _31be61c4,
    name: "settings-payment-add-method___ko"
  }, {
    path: "/ko/settings/payment/callback",
    component: _2f3fb954,
    name: "settings-payment-callback___ko"
  }, {
    path: "/tr/account/verify/expired",
    component: _d3e731ea,
    name: "account-verify-expired___tr"
  }, {
    path: "/tr/settings/payment/add-method",
    component: _31be61c4,
    name: "settings-payment-add-method___tr"
  }, {
    path: "/tr/settings/payment/callback",
    component: _2f3fb954,
    name: "settings-payment-callback___tr"
  }, {
    path: "/zh/account/verify/expired",
    component: _d3e731ea,
    name: "account-verify-expired___zh"
  }, {
    path: "/zh/settings/payment/add-method",
    component: _31be61c4,
    name: "settings-payment-add-method___zh"
  }, {
    path: "/zh/settings/payment/callback",
    component: _2f3fb954,
    name: "settings-payment-callback___zh"
  }, {
    path: "/ca/bedrooms/bookings/:id?",
    component: _4c76ead9,
    name: "bedrooms-bookings-id___ca"
  }, {
    path: "/ca/bedrooms/promotion/:id?",
    component: _27f59a70,
    name: "bedrooms-promotion-id___ca"
  }, {
    path: "/ca/whats-on/details/:id?",
    component: _4e2fbb96,
    name: "whats-on-details-id___ca"
  }, {
    path: "/de/bedrooms/bookings/:id?",
    component: _4c76ead9,
    name: "bedrooms-bookings-id___de"
  }, {
    path: "/de/bedrooms/promotion/:id?",
    component: _27f59a70,
    name: "bedrooms-promotion-id___de"
  }, {
    path: "/de/whats-on/details/:id?",
    component: _4e2fbb96,
    name: "whats-on-details-id___de"
  }, {
    path: "/en-us/bedrooms/bookings/:id?",
    component: _4c76ead9,
    name: "bedrooms-bookings-id___en-us"
  }, {
    path: "/en-us/bedrooms/promotion/:id?",
    component: _27f59a70,
    name: "bedrooms-promotion-id___en-us"
  }, {
    path: "/en-us/whats-on/details/:id?",
    component: _4e2fbb96,
    name: "whats-on-details-id___en-us"
  }, {
    path: "/es/bedrooms/bookings/:id?",
    component: _4c76ead9,
    name: "bedrooms-bookings-id___es"
  }, {
    path: "/es/bedrooms/promotion/:id?",
    component: _27f59a70,
    name: "bedrooms-promotion-id___es"
  }, {
    path: "/es/whats-on/details/:id?",
    component: _4e2fbb96,
    name: "whats-on-details-id___es"
  }, {
    path: "/fr/bedrooms/bookings/:id?",
    component: _4c76ead9,
    name: "bedrooms-bookings-id___fr"
  }, {
    path: "/fr/bedrooms/promotion/:id?",
    component: _27f59a70,
    name: "bedrooms-promotion-id___fr"
  }, {
    path: "/fr/whats-on/details/:id?",
    component: _4e2fbb96,
    name: "whats-on-details-id___fr"
  }, {
    path: "/ja/bedrooms/bookings/:id?",
    component: _4c76ead9,
    name: "bedrooms-bookings-id___ja"
  }, {
    path: "/ja/bedrooms/promotion/:id?",
    component: _27f59a70,
    name: "bedrooms-promotion-id___ja"
  }, {
    path: "/ja/whats-on/details/:id?",
    component: _4e2fbb96,
    name: "whats-on-details-id___ja"
  }, {
    path: "/ko/bedrooms/bookings/:id?",
    component: _4c76ead9,
    name: "bedrooms-bookings-id___ko"
  }, {
    path: "/ko/bedrooms/promotion/:id?",
    component: _27f59a70,
    name: "bedrooms-promotion-id___ko"
  }, {
    path: "/ko/whats-on/details/:id?",
    component: _4e2fbb96,
    name: "whats-on-details-id___ko"
  }, {
    path: "/tr/bedrooms/bookings/:id?",
    component: _4c76ead9,
    name: "bedrooms-bookings-id___tr"
  }, {
    path: "/tr/bedrooms/promotion/:id?",
    component: _27f59a70,
    name: "bedrooms-promotion-id___tr"
  }, {
    path: "/tr/whats-on/details/:id?",
    component: _4e2fbb96,
    name: "whats-on-details-id___tr"
  }, {
    path: "/zh/bedrooms/bookings/:id?",
    component: _4c76ead9,
    name: "bedrooms-bookings-id___zh"
  }, {
    path: "/zh/bedrooms/promotion/:id?",
    component: _27f59a70,
    name: "bedrooms-promotion-id___zh"
  }, {
    path: "/zh/whats-on/details/:id?",
    component: _4e2fbb96,
    name: "whats-on-details-id___zh"
  }, {
    path: "/ca/bedrooms/bookings/:id?/cancel",
    component: _a5731c74,
    name: "bedrooms-bookings-id-cancel___ca"
  }, {
    path: "/ca/bedrooms/bookings/:id?/modify",
    component: _7aa027f4,
    name: "bedrooms-bookings-id-modify___ca"
  }, {
    path: "/de/bedrooms/bookings/:id?/cancel",
    component: _a5731c74,
    name: "bedrooms-bookings-id-cancel___de"
  }, {
    path: "/de/bedrooms/bookings/:id?/modify",
    component: _7aa027f4,
    name: "bedrooms-bookings-id-modify___de"
  }, {
    path: "/en-us/bedrooms/bookings/:id?/cancel",
    component: _a5731c74,
    name: "bedrooms-bookings-id-cancel___en-us"
  }, {
    path: "/en-us/bedrooms/bookings/:id?/modify",
    component: _7aa027f4,
    name: "bedrooms-bookings-id-modify___en-us"
  }, {
    path: "/es/bedrooms/bookings/:id?/cancel",
    component: _a5731c74,
    name: "bedrooms-bookings-id-cancel___es"
  }, {
    path: "/es/bedrooms/bookings/:id?/modify",
    component: _7aa027f4,
    name: "bedrooms-bookings-id-modify___es"
  }, {
    path: "/fr/bedrooms/bookings/:id?/cancel",
    component: _a5731c74,
    name: "bedrooms-bookings-id-cancel___fr"
  }, {
    path: "/fr/bedrooms/bookings/:id?/modify",
    component: _7aa027f4,
    name: "bedrooms-bookings-id-modify___fr"
  }, {
    path: "/ja/bedrooms/bookings/:id?/cancel",
    component: _a5731c74,
    name: "bedrooms-bookings-id-cancel___ja"
  }, {
    path: "/ja/bedrooms/bookings/:id?/modify",
    component: _7aa027f4,
    name: "bedrooms-bookings-id-modify___ja"
  }, {
    path: "/ko/bedrooms/bookings/:id?/cancel",
    component: _a5731c74,
    name: "bedrooms-bookings-id-cancel___ko"
  }, {
    path: "/ko/bedrooms/bookings/:id?/modify",
    component: _7aa027f4,
    name: "bedrooms-bookings-id-modify___ko"
  }, {
    path: "/tr/bedrooms/bookings/:id?/cancel",
    component: _a5731c74,
    name: "bedrooms-bookings-id-cancel___tr"
  }, {
    path: "/tr/bedrooms/bookings/:id?/modify",
    component: _7aa027f4,
    name: "bedrooms-bookings-id-modify___tr"
  }, {
    path: "/zh/bedrooms/bookings/:id?/cancel",
    component: _a5731c74,
    name: "bedrooms-bookings-id-cancel___zh"
  }, {
    path: "/zh/bedrooms/bookings/:id?/modify",
    component: _7aa027f4,
    name: "bedrooms-bookings-id-modify___zh"
  }, {
    path: "/ca/bedrooms/bookings/:id?/cancel/cancelled",
    component: _50412b88,
    name: "bedrooms-bookings-id-cancel-cancelled___ca"
  }, {
    path: "/de/bedrooms/bookings/:id?/cancel/cancelled",
    component: _50412b88,
    name: "bedrooms-bookings-id-cancel-cancelled___de"
  }, {
    path: "/en-us/bedrooms/bookings/:id?/cancel/cancelled",
    component: _50412b88,
    name: "bedrooms-bookings-id-cancel-cancelled___en-us"
  }, {
    path: "/es/bedrooms/bookings/:id?/cancel/cancelled",
    component: _50412b88,
    name: "bedrooms-bookings-id-cancel-cancelled___es"
  }, {
    path: "/fr/bedrooms/bookings/:id?/cancel/cancelled",
    component: _50412b88,
    name: "bedrooms-bookings-id-cancel-cancelled___fr"
  }, {
    path: "/ja/bedrooms/bookings/:id?/cancel/cancelled",
    component: _50412b88,
    name: "bedrooms-bookings-id-cancel-cancelled___ja"
  }, {
    path: "/ko/bedrooms/bookings/:id?/cancel/cancelled",
    component: _50412b88,
    name: "bedrooms-bookings-id-cancel-cancelled___ko"
  }, {
    path: "/tr/bedrooms/bookings/:id?/cancel/cancelled",
    component: _50412b88,
    name: "bedrooms-bookings-id-cancel-cancelled___tr"
  }, {
    path: "/zh/bedrooms/bookings/:id?/cancel/cancelled",
    component: _50412b88,
    name: "bedrooms-bookings-id-cancel-cancelled___zh"
  }, {
    path: "/ca/bedrooms/bookings/:id?/modify/:availId/:rateId?",
    component: _28bb47d5,
    name: "bedrooms-bookings-id-modify-availId-rateId___ca"
  }, {
    path: "/de/bedrooms/bookings/:id?/modify/:availId/:rateId?",
    component: _28bb47d5,
    name: "bedrooms-bookings-id-modify-availId-rateId___de"
  }, {
    path: "/en-us/bedrooms/bookings/:id?/modify/:availId/:rateId?",
    component: _28bb47d5,
    name: "bedrooms-bookings-id-modify-availId-rateId___en-us"
  }, {
    path: "/es/bedrooms/bookings/:id?/modify/:availId/:rateId?",
    component: _28bb47d5,
    name: "bedrooms-bookings-id-modify-availId-rateId___es"
  }, {
    path: "/fr/bedrooms/bookings/:id?/modify/:availId/:rateId?",
    component: _28bb47d5,
    name: "bedrooms-bookings-id-modify-availId-rateId___fr"
  }, {
    path: "/ja/bedrooms/bookings/:id?/modify/:availId/:rateId?",
    component: _28bb47d5,
    name: "bedrooms-bookings-id-modify-availId-rateId___ja"
  }, {
    path: "/ko/bedrooms/bookings/:id?/modify/:availId/:rateId?",
    component: _28bb47d5,
    name: "bedrooms-bookings-id-modify-availId-rateId___ko"
  }, {
    path: "/tr/bedrooms/bookings/:id?/modify/:availId/:rateId?",
    component: _28bb47d5,
    name: "bedrooms-bookings-id-modify-availId-rateId___tr"
  }, {
    path: "/zh/bedrooms/bookings/:id?/modify/:availId/:rateId?",
    component: _28bb47d5,
    name: "bedrooms-bookings-id-modify-availId-rateId___zh"
  }, {
    path: "/ca/bedrooms/bookings/:id?/modify/:availId/:rateId?/book",
    component: _0254d839,
    name: "bedrooms-bookings-id-modify-availId-rateId-book___ca"
  }, {
    path: "/de/bedrooms/bookings/:id?/modify/:availId/:rateId?/book",
    component: _0254d839,
    name: "bedrooms-bookings-id-modify-availId-rateId-book___de"
  }, {
    path: "/en-us/bedrooms/bookings/:id?/modify/:availId/:rateId?/book",
    component: _0254d839,
    name: "bedrooms-bookings-id-modify-availId-rateId-book___en-us"
  }, {
    path: "/es/bedrooms/bookings/:id?/modify/:availId/:rateId?/book",
    component: _0254d839,
    name: "bedrooms-bookings-id-modify-availId-rateId-book___es"
  }, {
    path: "/fr/bedrooms/bookings/:id?/modify/:availId/:rateId?/book",
    component: _0254d839,
    name: "bedrooms-bookings-id-modify-availId-rateId-book___fr"
  }, {
    path: "/ja/bedrooms/bookings/:id?/modify/:availId/:rateId?/book",
    component: _0254d839,
    name: "bedrooms-bookings-id-modify-availId-rateId-book___ja"
  }, {
    path: "/ko/bedrooms/bookings/:id?/modify/:availId/:rateId?/book",
    component: _0254d839,
    name: "bedrooms-bookings-id-modify-availId-rateId-book___ko"
  }, {
    path: "/tr/bedrooms/bookings/:id?/modify/:availId/:rateId?/book",
    component: _0254d839,
    name: "bedrooms-bookings-id-modify-availId-rateId-book___tr"
  }, {
    path: "/zh/bedrooms/bookings/:id?/modify/:availId/:rateId?/book",
    component: _0254d839,
    name: "bedrooms-bookings-id-modify-availId-rateId-book___zh"
  }, {
    path: "/ca/bedrooms/availability/:availId?/:rateId?",
    component: _2781afac,
    name: "bedrooms-availability-availId-rateId___ca"
  }, {
    path: "/de/bedrooms/availability/:availId?/:rateId?",
    component: _2781afac,
    name: "bedrooms-availability-availId-rateId___de"
  }, {
    path: "/en-us/bedrooms/availability/:availId?/:rateId?",
    component: _2781afac,
    name: "bedrooms-availability-availId-rateId___en-us"
  }, {
    path: "/es/bedrooms/availability/:availId?/:rateId?",
    component: _2781afac,
    name: "bedrooms-availability-availId-rateId___es"
  }, {
    path: "/fr/bedrooms/availability/:availId?/:rateId?",
    component: _2781afac,
    name: "bedrooms-availability-availId-rateId___fr"
  }, {
    path: "/ja/bedrooms/availability/:availId?/:rateId?",
    component: _2781afac,
    name: "bedrooms-availability-availId-rateId___ja"
  }, {
    path: "/ko/bedrooms/availability/:availId?/:rateId?",
    component: _2781afac,
    name: "bedrooms-availability-availId-rateId___ko"
  }, {
    path: "/tr/bedrooms/availability/:availId?/:rateId?",
    component: _2781afac,
    name: "bedrooms-availability-availId-rateId___tr"
  }, {
    path: "/zh/bedrooms/availability/:availId?/:rateId?",
    component: _2781afac,
    name: "bedrooms-availability-availId-rateId___zh"
  }, {
    path: "/ca/bedrooms/availability/:availId?/:rateId?/book",
    component: _fd4e827c,
    name: "bedrooms-availability-availId-rateId-book___ca"
  }, {
    path: "/de/bedrooms/availability/:availId?/:rateId?/book",
    component: _fd4e827c,
    name: "bedrooms-availability-availId-rateId-book___de"
  }, {
    path: "/en-us/bedrooms/availability/:availId?/:rateId?/book",
    component: _fd4e827c,
    name: "bedrooms-availability-availId-rateId-book___en-us"
  }, {
    path: "/es/bedrooms/availability/:availId?/:rateId?/book",
    component: _fd4e827c,
    name: "bedrooms-availability-availId-rateId-book___es"
  }, {
    path: "/fr/bedrooms/availability/:availId?/:rateId?/book",
    component: _fd4e827c,
    name: "bedrooms-availability-availId-rateId-book___fr"
  }, {
    path: "/ja/bedrooms/availability/:availId?/:rateId?/book",
    component: _fd4e827c,
    name: "bedrooms-availability-availId-rateId-book___ja"
  }, {
    path: "/ko/bedrooms/availability/:availId?/:rateId?/book",
    component: _fd4e827c,
    name: "bedrooms-availability-availId-rateId-book___ko"
  }, {
    path: "/tr/bedrooms/availability/:availId?/:rateId?/book",
    component: _fd4e827c,
    name: "bedrooms-availability-availId-rateId-book___tr"
  }, {
    path: "/zh/bedrooms/availability/:availId?/:rateId?/book",
    component: _fd4e827c,
    name: "bedrooms-availability-availId-rateId-book___zh"
  }, {
    path: "/bedrooms/bookings/:id?",
    component: _4c76ead9,
    name: "bedrooms-bookings-id___en"
  }, {
    path: "/bedrooms/promotion/:id?",
    component: _27f59a70,
    name: "bedrooms-promotion-id___en"
  }, {
    path: "/ca/house/:slug?",
    component: _030055d2,
    name: "house-slug___ca"
  }, {
    path: "/ca/notes-depricated/:id?",
    component: _42136580,
    name: "notes-depricated-id___ca"
  }, {
    path: "/ca/perks/:id?",
    component: _53ff3b2c,
    name: "perks-id___ca"
  }, {
    path: "/ca/whats-on/:type?",
    component: _103ce8a1,
    name: "whats-on-type___ca"
  }, {
    path: "/de/house/:slug?",
    component: _030055d2,
    name: "house-slug___de"
  }, {
    path: "/de/notes-depricated/:id?",
    component: _42136580,
    name: "notes-depricated-id___de"
  }, {
    path: "/de/perks/:id?",
    component: _53ff3b2c,
    name: "perks-id___de"
  }, {
    path: "/de/whats-on/:type?",
    component: _103ce8a1,
    name: "whats-on-type___de"
  }, {
    path: "/en-us/house/:slug?",
    component: _030055d2,
    name: "house-slug___en-us"
  }, {
    path: "/en-us/notes-depricated/:id?",
    component: _42136580,
    name: "notes-depricated-id___en-us"
  }, {
    path: "/en-us/perks/:id?",
    component: _53ff3b2c,
    name: "perks-id___en-us"
  }, {
    path: "/en-us/whats-on/:type?",
    component: _103ce8a1,
    name: "whats-on-type___en-us"
  }, {
    path: "/es/house/:slug?",
    component: _030055d2,
    name: "house-slug___es"
  }, {
    path: "/es/notes-depricated/:id?",
    component: _42136580,
    name: "notes-depricated-id___es"
  }, {
    path: "/es/perks/:id?",
    component: _53ff3b2c,
    name: "perks-id___es"
  }, {
    path: "/es/whats-on/:type?",
    component: _103ce8a1,
    name: "whats-on-type___es"
  }, {
    path: "/fr/house/:slug?",
    component: _030055d2,
    name: "house-slug___fr"
  }, {
    path: "/fr/notes-depricated/:id?",
    component: _42136580,
    name: "notes-depricated-id___fr"
  }, {
    path: "/fr/perks/:id?",
    component: _53ff3b2c,
    name: "perks-id___fr"
  }, {
    path: "/fr/whats-on/:type?",
    component: _103ce8a1,
    name: "whats-on-type___fr"
  }, {
    path: "/ja/house/:slug?",
    component: _030055d2,
    name: "house-slug___ja"
  }, {
    path: "/ja/notes-depricated/:id?",
    component: _42136580,
    name: "notes-depricated-id___ja"
  }, {
    path: "/ja/perks/:id?",
    component: _53ff3b2c,
    name: "perks-id___ja"
  }, {
    path: "/ja/whats-on/:type?",
    component: _103ce8a1,
    name: "whats-on-type___ja"
  }, {
    path: "/ko/house/:slug?",
    component: _030055d2,
    name: "house-slug___ko"
  }, {
    path: "/ko/notes-depricated/:id?",
    component: _42136580,
    name: "notes-depricated-id___ko"
  }, {
    path: "/ko/perks/:id?",
    component: _53ff3b2c,
    name: "perks-id___ko"
  }, {
    path: "/ko/whats-on/:type?",
    component: _103ce8a1,
    name: "whats-on-type___ko"
  }, {
    path: "/tr/house/:slug?",
    component: _030055d2,
    name: "house-slug___tr"
  }, {
    path: "/tr/notes-depricated/:id?",
    component: _42136580,
    name: "notes-depricated-id___tr"
  }, {
    path: "/tr/perks/:id?",
    component: _53ff3b2c,
    name: "perks-id___tr"
  }, {
    path: "/tr/whats-on/:type?",
    component: _103ce8a1,
    name: "whats-on-type___tr"
  }, {
    path: "/whats-on/details/:id?",
    component: _4e2fbb96,
    name: "whats-on-details-id___en"
  }, {
    path: "/zh/house/:slug?",
    component: _030055d2,
    name: "house-slug___zh"
  }, {
    path: "/zh/notes-depricated/:id?",
    component: _42136580,
    name: "notes-depricated-id___zh"
  }, {
    path: "/zh/perks/:id?",
    component: _53ff3b2c,
    name: "perks-id___zh"
  }, {
    path: "/zh/whats-on/:type?",
    component: _103ce8a1,
    name: "whats-on-type___zh"
  }, {
    path: "/bedrooms/bookings/:id?/cancel",
    component: _a5731c74,
    name: "bedrooms-bookings-id-cancel___en"
  }, {
    path: "/bedrooms/bookings/:id?/modify",
    component: _7aa027f4,
    name: "bedrooms-bookings-id-modify___en"
  }, {
    path: "/ca/apply/:id/basics",
    component: _53be6956,
    name: "apply-id-basics___ca"
  }, {
    path: "/ca/apply/:id/details",
    component: _642e6df0,
    name: "apply-id-details___ca"
  }, {
    path: "/ca/apply/:id/package",
    component: _2b9d560c,
    name: "apply-id-package___ca"
  }, {
    path: "/ca/apply/:id/pay",
    component: _5745e524,
    name: "apply-id-pay___ca"
  }, {
    path: "/ca/apply/:id/review",
    component: _5f3bc4e8,
    name: "apply-id-review___ca"
  }, {
    path: "/ca/apply/:id/rules",
    component: _efbadf86,
    name: "apply-id-rules___ca"
  }, {
    path: "/ca/house/:slug?/rules",
    component: _286fe43f,
    name: "house-slug-rules___ca"
  }, {
    path: "/ca/house/:slug?/tours",
    component: _57949f63,
    name: "house-slug-tours___ca"
  }, {
    path: "/de/apply/:id/basics",
    component: _53be6956,
    name: "apply-id-basics___de"
  }, {
    path: "/de/apply/:id/details",
    component: _642e6df0,
    name: "apply-id-details___de"
  }, {
    path: "/de/apply/:id/package",
    component: _2b9d560c,
    name: "apply-id-package___de"
  }, {
    path: "/de/apply/:id/pay",
    component: _5745e524,
    name: "apply-id-pay___de"
  }, {
    path: "/de/apply/:id/review",
    component: _5f3bc4e8,
    name: "apply-id-review___de"
  }, {
    path: "/de/apply/:id/rules",
    component: _efbadf86,
    name: "apply-id-rules___de"
  }, {
    path: "/de/house/:slug?/rules",
    component: _286fe43f,
    name: "house-slug-rules___de"
  }, {
    path: "/de/house/:slug?/tours",
    component: _57949f63,
    name: "house-slug-tours___de"
  }, {
    path: "/en-us/apply/:id/basics",
    component: _53be6956,
    name: "apply-id-basics___en-us"
  }, {
    path: "/en-us/apply/:id/details",
    component: _642e6df0,
    name: "apply-id-details___en-us"
  }, {
    path: "/en-us/apply/:id/package",
    component: _2b9d560c,
    name: "apply-id-package___en-us"
  }, {
    path: "/en-us/apply/:id/pay",
    component: _5745e524,
    name: "apply-id-pay___en-us"
  }, {
    path: "/en-us/apply/:id/review",
    component: _5f3bc4e8,
    name: "apply-id-review___en-us"
  }, {
    path: "/en-us/apply/:id/rules",
    component: _efbadf86,
    name: "apply-id-rules___en-us"
  }, {
    path: "/en-us/house/:slug?/rules",
    component: _286fe43f,
    name: "house-slug-rules___en-us"
  }, {
    path: "/en-us/house/:slug?/tours",
    component: _57949f63,
    name: "house-slug-tours___en-us"
  }, {
    path: "/es/apply/:id/basics",
    component: _53be6956,
    name: "apply-id-basics___es"
  }, {
    path: "/es/apply/:id/details",
    component: _642e6df0,
    name: "apply-id-details___es"
  }, {
    path: "/es/apply/:id/package",
    component: _2b9d560c,
    name: "apply-id-package___es"
  }, {
    path: "/es/apply/:id/pay",
    component: _5745e524,
    name: "apply-id-pay___es"
  }, {
    path: "/es/apply/:id/review",
    component: _5f3bc4e8,
    name: "apply-id-review___es"
  }, {
    path: "/es/apply/:id/rules",
    component: _efbadf86,
    name: "apply-id-rules___es"
  }, {
    path: "/es/house/:slug?/rules",
    component: _286fe43f,
    name: "house-slug-rules___es"
  }, {
    path: "/es/house/:slug?/tours",
    component: _57949f63,
    name: "house-slug-tours___es"
  }, {
    path: "/fr/apply/:id/basics",
    component: _53be6956,
    name: "apply-id-basics___fr"
  }, {
    path: "/fr/apply/:id/details",
    component: _642e6df0,
    name: "apply-id-details___fr"
  }, {
    path: "/fr/apply/:id/package",
    component: _2b9d560c,
    name: "apply-id-package___fr"
  }, {
    path: "/fr/apply/:id/pay",
    component: _5745e524,
    name: "apply-id-pay___fr"
  }, {
    path: "/fr/apply/:id/review",
    component: _5f3bc4e8,
    name: "apply-id-review___fr"
  }, {
    path: "/fr/apply/:id/rules",
    component: _efbadf86,
    name: "apply-id-rules___fr"
  }, {
    path: "/fr/house/:slug?/rules",
    component: _286fe43f,
    name: "house-slug-rules___fr"
  }, {
    path: "/fr/house/:slug?/tours",
    component: _57949f63,
    name: "house-slug-tours___fr"
  }, {
    path: "/ja/apply/:id/basics",
    component: _53be6956,
    name: "apply-id-basics___ja"
  }, {
    path: "/ja/apply/:id/details",
    component: _642e6df0,
    name: "apply-id-details___ja"
  }, {
    path: "/ja/apply/:id/package",
    component: _2b9d560c,
    name: "apply-id-package___ja"
  }, {
    path: "/ja/apply/:id/pay",
    component: _5745e524,
    name: "apply-id-pay___ja"
  }, {
    path: "/ja/apply/:id/review",
    component: _5f3bc4e8,
    name: "apply-id-review___ja"
  }, {
    path: "/ja/apply/:id/rules",
    component: _efbadf86,
    name: "apply-id-rules___ja"
  }, {
    path: "/ja/house/:slug?/rules",
    component: _286fe43f,
    name: "house-slug-rules___ja"
  }, {
    path: "/ja/house/:slug?/tours",
    component: _57949f63,
    name: "house-slug-tours___ja"
  }, {
    path: "/ko/apply/:id/basics",
    component: _53be6956,
    name: "apply-id-basics___ko"
  }, {
    path: "/ko/apply/:id/details",
    component: _642e6df0,
    name: "apply-id-details___ko"
  }, {
    path: "/ko/apply/:id/package",
    component: _2b9d560c,
    name: "apply-id-package___ko"
  }, {
    path: "/ko/apply/:id/pay",
    component: _5745e524,
    name: "apply-id-pay___ko"
  }, {
    path: "/ko/apply/:id/review",
    component: _5f3bc4e8,
    name: "apply-id-review___ko"
  }, {
    path: "/ko/apply/:id/rules",
    component: _efbadf86,
    name: "apply-id-rules___ko"
  }, {
    path: "/ko/house/:slug?/rules",
    component: _286fe43f,
    name: "house-slug-rules___ko"
  }, {
    path: "/ko/house/:slug?/tours",
    component: _57949f63,
    name: "house-slug-tours___ko"
  }, {
    path: "/tr/apply/:id/basics",
    component: _53be6956,
    name: "apply-id-basics___tr"
  }, {
    path: "/tr/apply/:id/details",
    component: _642e6df0,
    name: "apply-id-details___tr"
  }, {
    path: "/tr/apply/:id/package",
    component: _2b9d560c,
    name: "apply-id-package___tr"
  }, {
    path: "/tr/apply/:id/pay",
    component: _5745e524,
    name: "apply-id-pay___tr"
  }, {
    path: "/tr/apply/:id/review",
    component: _5f3bc4e8,
    name: "apply-id-review___tr"
  }, {
    path: "/tr/apply/:id/rules",
    component: _efbadf86,
    name: "apply-id-rules___tr"
  }, {
    path: "/tr/house/:slug?/rules",
    component: _286fe43f,
    name: "house-slug-rules___tr"
  }, {
    path: "/tr/house/:slug?/tours",
    component: _57949f63,
    name: "house-slug-tours___tr"
  }, {
    path: "/zh/apply/:id/basics",
    component: _53be6956,
    name: "apply-id-basics___zh"
  }, {
    path: "/zh/apply/:id/details",
    component: _642e6df0,
    name: "apply-id-details___zh"
  }, {
    path: "/zh/apply/:id/package",
    component: _2b9d560c,
    name: "apply-id-package___zh"
  }, {
    path: "/zh/apply/:id/pay",
    component: _5745e524,
    name: "apply-id-pay___zh"
  }, {
    path: "/zh/apply/:id/review",
    component: _5f3bc4e8,
    name: "apply-id-review___zh"
  }, {
    path: "/zh/apply/:id/rules",
    component: _efbadf86,
    name: "apply-id-rules___zh"
  }, {
    path: "/zh/house/:slug?/rules",
    component: _286fe43f,
    name: "house-slug-rules___zh"
  }, {
    path: "/zh/house/:slug?/tours",
    component: _57949f63,
    name: "house-slug-tours___zh"
  }, {
    path: "/bedrooms/bookings/:id?/cancel/cancelled",
    component: _50412b88,
    name: "bedrooms-bookings-id-cancel-cancelled___en"
  }, {
    path: "/bedrooms/bookings/:id?/modify/:availId/:rateId?",
    component: _28bb47d5,
    name: "bedrooms-bookings-id-modify-availId-rateId___en"
  }, {
    path: "/bedrooms/bookings/:id?/modify/:availId/:rateId?/book",
    component: _0254d839,
    name: "bedrooms-bookings-id-modify-availId-rateId-book___en"
  }, {
    path: "/bedrooms/availability/:availId?/:rateId?",
    component: _2781afac,
    name: "bedrooms-availability-availId-rateId___en"
  }, {
    path: "/bedrooms/availability/:availId?/:rateId?/book",
    component: _fd4e827c,
    name: "bedrooms-availability-availId-rateId-book___en"
  }, {
    path: "/ca/:route*",
    component: _645997cb,
    meta: {"hasOwnTheme":true},
    name: "sitecore-jss___ca"
  }, {
    path: "/de/:route*",
    component: _645997cb,
    meta: {"hasOwnTheme":true},
    name: "sitecore-jss___de"
  }, {
    path: "/en-us/:route*",
    component: _645997cb,
    meta: {"hasOwnTheme":true},
    name: "sitecore-jss___en-us"
  }, {
    path: "/es/:route*",
    component: _645997cb,
    meta: {"hasOwnTheme":true},
    name: "sitecore-jss___es"
  }, {
    path: "/fr/:route*",
    component: _645997cb,
    meta: {"hasOwnTheme":true},
    name: "sitecore-jss___fr"
  }, {
    path: "/house/:slug?",
    component: _030055d2,
    name: "house-slug___en"
  }, {
    path: "/ja/:route*",
    component: _645997cb,
    meta: {"hasOwnTheme":true},
    name: "sitecore-jss___ja"
  }, {
    path: "/ko/:route*",
    component: _645997cb,
    meta: {"hasOwnTheme":true},
    name: "sitecore-jss___ko"
  }, {
    path: "/notes-depricated/:id?",
    component: _42136580,
    name: "notes-depricated-id___en"
  }, {
    path: "/perks/:id?",
    component: _53ff3b2c,
    name: "perks-id___en"
  }, {
    path: "/tr/:route*",
    component: _645997cb,
    meta: {"hasOwnTheme":true},
    name: "sitecore-jss___tr"
  }, {
    path: "/whats-on/:type?",
    component: _103ce8a1,
    name: "whats-on-type___en"
  }, {
    path: "/zh/:route*",
    component: _645997cb,
    meta: {"hasOwnTheme":true},
    name: "sitecore-jss___zh"
  }, {
    path: "/apply/:id/basics",
    component: _53be6956,
    name: "apply-id-basics___en"
  }, {
    path: "/apply/:id/details",
    component: _642e6df0,
    name: "apply-id-details___en"
  }, {
    path: "/apply/:id/package",
    component: _2b9d560c,
    name: "apply-id-package___en"
  }, {
    path: "/apply/:id/pay",
    component: _5745e524,
    name: "apply-id-pay___en"
  }, {
    path: "/apply/:id/review",
    component: _5f3bc4e8,
    name: "apply-id-review___en"
  }, {
    path: "/apply/:id/rules",
    component: _efbadf86,
    name: "apply-id-rules___en"
  }, {
    path: "/house/:slug?/rules",
    component: _286fe43f,
    name: "house-slug-rules___en"
  }, {
    path: "/house/:slug?/tours",
    component: _57949f63,
    name: "house-slug-tours___en"
  }, {
    path: "/",
    component: _645997cb,
    name: "index___en"
  }, {
    path: "/:route*",
    component: _645997cb,
    meta: {"hasOwnTheme":true},
    name: "sitecore-jss___en"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
